import React, { useState } from 'react';

/**
 * Super simple install page - email input + videos + copy templates
 * URL: /install
 */
export function InstallPage() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  const handleAddToTestFlight = async (e) => {
    e.preventDefault();
    if (!email) {
      setMessage('Enter your Apple ID email');
      return;
    }

    setLoading(true);
    setMessage('');

    try {
      const response = await fetch('https://property-lookup-api.anassk.workers.dev/testflight/invite', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: email.trim().toLowerCase(),
          firstName: 'Team',
          lastName: 'Member'
        })
      });

      const data = await response.json();
      if (data.success) {
        setMessage('✅ Added! Check your email for Apple\'s invite.');
        setEmail('');
      } else {
        setMessage(`Error: ${data.error || 'Something went wrong'}`);
      }
    } catch (e) {
      setMessage('Error. Try again.');
    }
    setLoading(false);
  };

  return (
    <div style={{ maxWidth: '600px', margin: '0 auto', padding: '20px', fontFamily: 'system-ui, sans-serif' }}>
      {/* Header */}
      <h1 style={{ textAlign: 'center', marginBottom: '8px' }}>🚀 RoofLeads v1.3</h1>
      <p style={{ textAlign: 'center', color: '#666', marginBottom: '32px' }}>Real-time Storm Alerts + Daily Reminders</p>

      {/* Form */}
      <div style={{ background: '#f0f9ff', padding: '20px', borderRadius: '12px', marginBottom: '24px', border: '2px solid #0096c7' }}>
        <h2 style={{ margin: '0 0 12px', fontSize: '18px' }}>⚡ Add to TestFlight</h2>
        <p style={{ margin: '0 0 16px', fontSize: '14px', color: '#666' }}>Enter your Apple ID email → We add you → Check your email for invite</p>

        <form onSubmit={handleAddToTestFlight} style={{ display: 'flex', gap: '8px', marginBottom: '12px' }}>
          <input
            type="email"
            placeholder="your@email.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={{
              flex: 1,
              padding: '12px',
              border: '1px solid #ccc',
              borderRadius: '6px',
              fontSize: '14px'
            }}
          />
          <button
            type="submit"
            disabled={loading}
            style={{
              padding: '12px 20px',
              background: '#0096c7',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              fontWeight: 'bold',
              cursor: loading ? 'wait' : 'pointer',
              whiteSpace: 'nowrap'
            }}
          >
            {loading ? 'Adding...' : '✅ Add Me'}
          </button>
        </form>

        {message && (
          <div style={{
            padding: '12px',
            background: message.includes('✅') ? '#e8f5e9' : '#ffebee',
            color: message.includes('✅') ? '#2e7d32' : '#c62828',
            borderRadius: '6px',
            fontSize: '13px'
          }}>
            {message}
          </div>
        )}
      </div>

      {/* Videos */}
      <div style={{ marginBottom: '24px' }}>
        <h2 style={{ fontSize: '16px', marginBottom: '12px' }}>📺 Watch These Videos First</h2>

        <div style={{ marginBottom: '16px' }}>
          <p style={{ margin: '0 0 8px', fontWeight: 'bold' }}>1️⃣ Apple ID Setup (2 min)</p>
          <iframe
            width="100%"
            height="180"
            src="https://www.youtube.com/embed/lUOwdOGwfd0"
            title="Apple ID Setup"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            style={{ borderRadius: '8px' }}
          ></iframe>
        </div>

        <div>
          <p style={{ margin: '0 0 8px', fontWeight: 'bold' }}>2️⃣ Install TestFlight (2 min)</p>
          <iframe
            width="100%"
            height="180"
            src="https://www.youtube.com/embed/z7gFfEEbW0k"
            title="TestFlight Install"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            style={{ borderRadius: '8px' }}
          ></iframe>
        </div>
      </div>

      {/* Copy Templates */}
      <div style={{ background: '#f5f5f5', padding: '16px', borderRadius: '8px' }}>
        <h2 style={{ fontSize: '16px', margin: '0 0 12px' }}>📱 Share With Team</h2>

        <button
          onClick={() => {
            const text = `🚀 RoofLeads v1.3 ready!\n\n⚡ FAST TRACK:\nhttps://leadgenatr.pages.dev/install\n\nJust enter your Apple ID email and click "Add Me" → Check your email for the invite → Install from TestFlight\n\nTakes 5 minutes total. ✅`;
            navigator.clipboard.writeText(text);
            alert('WhatsApp/SMS text copied!');
          }}
          style={{
            width: '100%',
            padding: '12px',
            background: '#25D366',
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            fontWeight: 'bold',
            marginBottom: '8px',
            cursor: 'pointer'
          }}
        >
          💬 Copy WhatsApp/SMS
        </button>

        <button
          onClick={() => {
            const text = `Subject: 🚀 RoofLeads v1.3 - Install in 5 Minutes\n\nHi [Name],\n\nRoofLeads v1.3 is ready! Go here: https://leadgenatr.pages.dev/install\n\nStep 1: Enter your Apple ID email\nStep 2: Click "Add Me"\nStep 3: Check your email for the Apple invite\nStep 4: Open TestFlight and install RoofLeads\nStep 5: Login and start using!\n\n⏱️ Takes 5 minutes total.\n\nNew features:\n- Real-time storm alerts ⛈️\n- Daily plan reminders 📋\n- Conversion tracker 📊\n\nLet me know if you need help!\n\nThanks,\n[Your name]`;
            navigator.clipboard.writeText(text);
            alert('Email text copied!');
          }}
          style={{
            width: '100%',
            padding: '12px',
            background: '#0096c7',
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            fontWeight: 'bold',
            cursor: 'pointer'
          }}
        >
          ✉️ Copy Email
        </button>
      </div>

      {/* Tracker Link */}
      <div style={{ textAlign: 'center', marginTop: '24px' }}>
        <a href="/tracker" style={{
          display: 'inline-block',
          padding: '12px 24px',
          background: '#f77f00',
          color: 'white',
          textDecoration: 'none',
          borderRadius: '6px',
          fontWeight: 'bold'
        }}>
          📊 Track Installations
        </a>
      </div>
    </div>
  );
}

export default InstallPage;
